import { render, staticRenderFns } from "./bottom_tabs.vue?vue&type=template&id=286b9e3c&scoped=true"
import script from "./bottom_tabs.vue?vue&type=script&lang=js"
export * from "./bottom_tabs.vue?vue&type=script&lang=js"
import style0 from "./bottom_tabs.vue?vue&type=style&index=0&id=286b9e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b9e3c",
  null
  
)

export default component.exports